import { IAuthorizationsView } from '../admin/iAuthorizationsView';
import { IGroup } from '../admin/iGroup';
import { IModule } from '../admin/iModule';
import { IProject } from '../admin/iProject';
import { ISectionsColumn } from '../admin/iSectionsColumn';
import { IUser } from '../admin/iUser';
import { IWidget } from '../admin/iWidget';
export interface IAuth {
  authUser?: IUser | null;
  authorizations?: IAuthorizationsView[] | null;
  navigationMenu?: IModule[] | null;
  widgets?: IWidget[] | null;
  sectionsColumns?: ISectionsColumn[] | null;
  groups?: IGroup[] | null;
  projects?: IProject[] | null;
}

class AuthClass implements IAuth {
  authUser;
  authorizations;
  navigationMenu;
  widgets;
  sectionsColumns;
  groups;
  projects;

  constructor(
    authUser?: IUser,
    authorizations?: IAuthorizationsView[],
    navigationMenu?: IModule[],
    widgets?: IWidget[],
    sectionsColumns?: ISectionsColumn[],
    groups?: IGroup[],
    projects?: IProject[],
  ) {
    this.authUser = authUser ?? null;
    this.authorizations = authorizations ?? null;
    this.navigationMenu = navigationMenu ?? null;
    this.widgets = widgets ?? null;
    this.sectionsColumns = sectionsColumns ?? null;
    this.groups = groups ?? null;
    this.projects = projects ?? null;
  }
}

export default AuthClass;
